export const colors = {
  azureRadiance: '#0076ff',
  gamboge: '#E49D0B'
}